"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterEditModalButton = LetterEditModalButton;
exports.OurLetterEditModalButton = OurLetterEditModalButton;
exports.OurLetterAddNewModalButton = OurLetterAddNewModalButton;
exports.IncomingLetterEditModalButton = IncomingLetterEditModalButton;
exports.IncomingLetterAddNewModalButton = IncomingLetterAddNewModalButton;
exports.RespondToLetterButton = RespondToLetterButton;
exports.ExportOurLetterContractToPDFButton = ExportOurLetterContractToPDFButton;
exports.ExportOurLetterToPDFAction = ExportOurLetterToPDFAction;
const react_1 = __importStar(require("react"));
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const GeneralModal_1 = require("../../../View/Modals/GeneralModal");
const LetterModalBody_1 = require("./LetterModalBody");
const LetterValidationSchema_1 = require("./LetterValidationSchema");
const IncomingLetterModalBody_1 = require("./IncomingLetterModalBody");
const OurLetterModalBody_1 = require("./OurLetterModalBody");
const LettersController_1 = require("../LettersController");
const react_bootstrap_1 = require("react-bootstrap");
const CommonComponents_1 = require("../../../View/Resultsets/CommonComponents");
const FilterableTableContext_1 = require("../../../View/Resultsets/FilterableTable/FilterableTableContext");
/** przycisk i modal edycji Letter */
function LetterEditModalButton({ modalProps: { onEdit, initialData }, buttonProps, }) {
    (0, react_1.useEffect)(() => { }, [initialData]);
    return initialData.isOur ? (react_1.default.createElement(OurLetterEditModalButton, { modalProps: { onEdit, initialData }, buttonProps: buttonProps })) : (react_1.default.createElement(IncomingLetterEditModalButton, { modalProps: { onEdit, initialData }, buttonProps: buttonProps }));
}
function OurLetterEditModalButton({ modalProps: { onEdit, initialData }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: OurLetterModalBody_1.OurLetterModalBody,
            modalTitle: "Edycja pisma wychodzącego",
            repository: LettersController_1.lettersRepository,
            initialData: initialData,
            makeValidationSchema: LetterValidationSchema_1.ourLetterValidationSchema,
            // panel "Nowa sprawa" (InlineCreateDrawer) działa też w edycji pisma
            enforceFocus: false,
        }, buttonProps: {
            buttonVariant: "outline-success",
        } }));
}
function OurLetterAddNewModalButton({ modalProps: { onAddNew }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: LetterModalBody_1.ProjectSelectorModalBody,
            additionalModalBodyProps: { SpecificLetterModalBody: OurLetterModalBody_1.OurLetterModalBody },
            modalTitle: "Rejestruj pismo wychodzące",
            repository: LettersController_1.lettersRepository,
            makeValidationSchema: LetterValidationSchema_1.ourLetterValidationSchema,
            // host modala pisma musi puścić focus do panelu "Nowa sprawa" (InlineCreateDrawer)
            enforceFocus: false,
        }, buttonProps: {
            buttonCaption: "Rejestruj wychodzące",
            buttonVariant: "outline-success",
        } }));
}
function IncomingLetterEditModalButton({ modalProps: { onEdit, initialData }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: IncomingLetterModalBody_1.IncomingLetterModalBody,
            modalTitle: "Edycja pisma przychodzącego",
            repository: LettersController_1.lettersRepository,
            initialData: initialData,
            makeValidationSchema: LetterValidationSchema_1.makeOtherLetterValidationSchema,
            // panel "Nowa sprawa" (InlineCreateDrawer) działa też w edycji pisma
            enforceFocus: false,
        }, buttonProps: {} }));
}
function IncomingLetterAddNewModalButton({ modalProps: { onAddNew }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: LetterModalBody_1.ProjectSelectorModalBody,
            additionalModalBodyProps: { SpecificLetterModalBody: IncomingLetterModalBody_1.IncomingLetterModalBody }, // additional props for ProjectSelectorModalBody
            modalTitle: "Nowe pismo przychodzące",
            repository: LettersController_1.lettersRepository,
            makeValidationSchema: LetterValidationSchema_1.makeOtherLetterValidationSchema,
            // host modala pisma musi puścić focus do panelu "Nowa sprawa" (InlineCreateDrawer)
            enforceFocus: false,
        }, buttonProps: {
            buttonCaption: "Rejestruj przychodzące",
        } }));
}
/** ikona "Odpowiedz" (jak w kliencie pocztowym) w menu akcji wiersza — dla obu kierunków.
 * Odpowiedź jest zawsze pismem w kierunku przeciwnym do źródłowego:
 *   - na pismo przychodzące → rejestracja pisma wychodzącego (nasza odpowiedź, z szablonem),
 *   - na pismo wychodzące   → rejestracja pisma przychodzącego (odpowiedź kontrahenta, z plikiem).
 * Pola wypełniane na podstawie pisma źródłowego: projekt, sprawy (→ kontrakt),
 * podmiot (odbiorca ↔ nadawca) oraz relatedLetterNumber (powiązanie ze źródłem). */
function RespondToLetterButton({ dataObject, layout, }) {
    const { handleAddObject } = (0, FilterableTableContext_1.useFilterableTableContext)();
    const [showForm, setShowForm] = (0, react_1.useState)(false);
    // odpowiadamy pismem w kierunku przeciwnym do źródłowego
    const replyIsOur = !dataObject.isOur;
    // stabilna referencja: useEffect-y w LetterModalBody/OurLetterModalBody robią reset(initialData),
    // więc nowy obiekt przy każdym renderze czyściłby formularz w trakcie wypełniania
    const replyInitialData = react_1.default.useMemo(() => ({
        _project: dataObject._project,
        _cases: dataObject._cases,
        _entitiesMain: dataObject._entitiesMain,
        description: dataObject.description
            ? `Odpowiedź na: ${dataObject.description}`.slice(0, 300)
            : "",
        relatedLetterNumber: dataObject.number ? String(dataObject.number) : "",
        isOur: replyIsOur,
    }), [dataObject, replyIsOur]);
    // bez _cases nie da się wywieść kontraktu (ContractSelector readOnly w trybie add) — formularz byłby nie do zapisania
    if (!dataObject._cases?.length)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CommonComponents_1.ReplyIconButton, { layout: layout, onClick: () => setShowForm(true) }),
        react_1.default.createElement(GeneralModal_1.GeneralModal, { show: showForm, onClose: () => setShowForm(false), isEditing: false, title: `Odpowiedź na pismo ${dataObject.number ?? ""}`, subtitle: dataObject.description ? `Dotyczy: ${dataObject.description}` : undefined, repository: LettersController_1.lettersRepository, onAddNew: handleAddObject, ModalBodyComponent: replyIsOur ? OurLetterModalBody_1.OurLetterModalBody : IncomingLetterModalBody_1.IncomingLetterModalBody, makeValidationSchema: replyIsOur ? LetterValidationSchema_1.ourLetterValidationSchema : LetterValidationSchema_1.makeOtherLetterValidationSchema, modalBodyProps: {
                isEditing: false,
                initialData: replyInitialData,
            }, 
            // host modala pisma musi puścić focus do panelu "Nowa sprawa" (InlineCreateDrawer)
            enforceFocus: false })));
}
/** Eksport pisma do PDF — pozycja menu akcji wiersza; tylko dla pism naszych. */
function ExportOurLetterContractToPDFButton({ dataObject, layout, }) {
    return react_1.default.createElement(ExportOurLetterToPDFAction, { dataObject: dataObject, layout: layout, repository: LettersController_1.lettersRepository });
}
/**
 * Wspólna akcja „PDF” dla rejestru pism kontraktowych i ofertowych: ta sama trasa serwera
 * (`exportOurLetterToPDF`), różni się tylko repozytorium, przez które idzie żądanie.
 */
function ExportOurLetterToPDFAction({ dataObject, layout, repository, }) {
    const [requestPending, setRequestPending] = (0, react_1.useState)(false);
    const [showSuccessToast, setShowSuccessToast] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)(null);
    if (!dataObject.isOur)
        return null;
    async function handleClick() {
        try {
            setRequestPending(true);
            await repository.fetch("exportOurLetterToPDF", dataObject);
            setRequestPending(false);
            setShowSuccessToast(true);
        }
        catch (error) {
            setRequestPending(false);
            if (error instanceof Error)
                setErrorMessage(error.message);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        requestPending ? (react_1.default.createElement(react_bootstrap_1.Spinner, { as: "span", animation: "border", size: "sm", role: "status", "aria-hidden": "true" })) : (react_1.default.createElement(CommonComponents_1.PdfIconButton, { layout: layout, onClick: handleClick })),
        react_1.default.createElement(CommonComponents_1.SuccessToast, { message: "Eksport do PDF zako\u0144czy\u0142 si\u0119 powodzeniem!", show: showSuccessToast, onClose: () => setShowSuccessToast(false) }),
        react_1.default.createElement(CommonComponents_1.SuccessToast, { header: "B\u0142\u0105d eksportu do PDF", message: errorMessage ?? "", bg: "danger", show: !!errorMessage, onClose: () => setErrorMessage(null) })));
}
